import firebase from 'firebase'
import firebaseUiAuthCss from 'firebaseui/dist/firebaseui.css' /* eslint no-unused-vars: 0 */
import * as firebaseui from 'firebaseui'
import store from '../Store/vuex'

const user = {
  displayName: '',
  failedLogin: '',
  email: '',
  emailVerified: false,
  photoURL: '',
  uid: '',
  firebaseUI: null
}

const dbuser = {}

const getUser = () => {
  return user
}

const authUser = () => {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((theUser) => {      
       _checkUser(theUser).then(function(){
         resolve(theUser)
       })
    }, (error) => {
      console.log(error)
    })
  })
}

const updateUser = (userUpdated) => {
  var FBUser = firebase.auth().currentUser;
  FBUser.updateProfile(userUpdated).then(function() {
    // Update successful.
    user.displayName = userUpdated.displayName
    user.email = userUpdated.email
  }, function(error) {
    // An error happened.
  });
}

const logout = () => {
  firebase.auth().signOut().then(() => {
    // Sign-out successful.
    window.location.reload()
  }, (error) => {
    // An error happened.
    console.log(error)
    window.location.reload()
  })
}

const _checkUser = async (theUser) => {
  if (theUser) {
    //Orgs and role functionality
    if(store.state.usermain.loggedIn == false){
      var database = firebase.database();
      await database.ref(`/users/${theUser.uid}`).once('value').then(function(snapshot) {
        //Check if user exists in database
        if(snapshot.val()){
          //Find an active org and set curOrg to it
          var curOrg = null;
          var orgs = snapshot.val().orgs
          for(var org in orgs){
            if(orgs[org].active){
              curOrg = {
                id: org,
                name: orgs[org].name,
                role: orgs[org].role
              }
              break;
            }
          }
          //If active org found, allow login and set variables
          if(curOrg){
            //Set user
            user.displayName = theUser.displayName
            user.email = theUser.email
            user.emailVerified = theUser.emailVerified
            user.photoURL = theUser.photoURL
            user.uid = theUser.uid
            //Set store values
            store.commit('setCurOrg', curOrg);
            store.commit('setLoggedin', true)
            //If no name, redirect to profile to set name and password
            
          }else{
            //No active org so deny login
            _authFailed('You are not allowed to access this system.')
          }
        }else{
          //No user in database
          _authFailed('You are not allowed to access this system.')
        }

      });
    } 
  } else {
    _authFailed('')
  }
}

const _authFailed = async (message) => {
  user.failedLogin = message
  user.displayName = ''
  user.email = ''
  user.emailVerified = false
  user.photoURL = ''
  user.uid = ''
  _initAuthUI()
}

const _initAuthUI = () => {
  console.log("FUCK OFF");

  const uiConfig = {
    signInSuccessUrl: '/',
    signInOptions: [
      // Leave the lines as is for the providers you want to offer your users.
      firebase.auth.EmailAuthProvider.PROVIDER_ID
    ],
    // Terms of service url.
    tosUrl: '/',
    //Account Choose Disable
    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    callbacks: {
      signInSuccessWithAuthResult: function(authResult, redirectUrl) {
        console.log("SIGNING IN");

        return authUser().then(() => {
          console.log("NEW USER " + user.id);
          // Manually redirect.
          window.location.assign('/');
          // Do not automatically redirect.
          return true;
        })
      }
    }
  }
  // Initialize the FirebaseUI Widget using Firebase.
  if(!user.firebaseUI){
    user.firebaseUI = new firebaseui.auth.AuthUI(firebase.auth())
  }
  // The start method will wait until the DOM is loaded.
  user.firebaseUI.start('#firebaseui-auth-container', uiConfig)
  console.log("STARTED AUTH UI");
}

export default { getUser, logout, authUser, updateUser }


// WEBPACK FOOTER //
// ./src/components/webmaster/Authentication/auth.js